module.exports = __webpack_public_path__ + "img/motor-boat.53bf8bcf.png";